import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24, background: '#fff', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist or has moved."
        extra={
          <>
            <Button type="primary" onClick={() => navigate('/dashboard')} style={{ marginRight: 8 }}>
              Go to Dashboard
            </Button>
            <Button onClick={() => navigate(-1)}>Go Back</Button>
          </>
        }
      />
    </div>
  );
};

export default NotFound;


